<template>
  <div class="listInput">
    <div class="listInput-header">
      <div class="listInput-name">{{name}} - {{value.length}}</div>
      <div class="listInput-buttonHolder">
        <button-com
          iconName="list-add"
          iconSize="large"
          iconCircleColor="#F0F0F0"
          class="bm-ghost bm-onlyIcon"
          tooltip="Lägg till"
          @click.native="addItem"
        ></button-com>
      </div>
    </div>
    <div class="listInput-item" v-for="(item, index) in value">
      <div class="listInput-inputButtonHolder">
        <button-com
          iconName="delete"
          class="bm-ghost bm-onlyIcon"
          tooltip="Delete"
          @click.native="removeItem(index)"
        ></button-com>
      </div>
      <input type="text" @input="updateItem({$event, index})" :value="item" placeholder="...">
    </div>
    <div class="listInput-empty" v-if="value.length === 0">
      Inga {{name}} har lagts till
    </div>
  </div>
</template>

<script>
import Input from '@/inputs/Input'

export default {
  extends: Input,
  props: ['name'],
  methods: {
    updateItem ({$event, index}) {
      const [...value] = this.value
      value[index] = $event.target.value
      this.updateInput('value', value)
    },
    addItem () {
      const [...value] = this.value
      value.push('')
      this.updateInput('value', value)
    },
    removeItem (inIndex) {
      const filtered = this.value.filter((item, index) => { return index !== inIndex })
      this.updateInput('value', filtered)
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('listInput')

  +element('header')
    height: 40px
    margin-bottom: 25px
    line-height: 40px
    display: flex
    position: relative
    width: 100%

  +element('buttonHolder')
    position: absolute
    right: 0

  +element('inputButtonHolder')
    position: absolute
    width: 40px
    height: 40px
    right: 5px
    top: 5px

  +element('name')
    padding-left: 25px
    text-transform: capitalize
    font-size: 12px

  +element('item')
    margin-bottom: 10px
    position: relative

  +element('empty')
    text-align: center
    height: 50px
    border-radius: 50px
    border: 2px dashed $divider
    line-height: 48px
    box-sizing: border-box
    margin-bottom: 10px

</style>



// WEBPACK FOOTER //
// src/inputs/List.vue